import {client} from '../helpers/api';

export async function postRegisterKidsProfile(kids) {
  const body = {
    kids: kids.map(({studentName, gender, gradeId, dob}) => ({
      student_name: studentName,
      gender,
      grade: gradeId,
      dob,
    })),
  };

  const response = await client.post('/api/kids', body);

  if (response.data?.status) {
    return response.data?.message || 'Success';
  } else if (response.data?.status === false) {
    return response.data?.message || '';
  }
  throw response;
}
